import { type PropsWithChildren, createElement, memo } from "react";

import he from "he";

import { type TTailwindString } from "classnames";

type HeadingLevel =
  | "display"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "span";

type Props = {
  as: Exclude<HeadingLevel, "display">;
  className?: TTailwindString;
  id?: string;
};

const HeadingViewBase = ({
  as,
  children,
  className,
  id,
}: PropsWithChildren<Props>) => {
  const content = typeof children === "string" ? he.decode(children) : children;
  return createElement(as, { className, id }, content);
};

export const HeadingView = memo(HeadingViewBase);
